/*
  nn-set-design-picker.js
  ------------------------------------------------------------
  セット商品ページ（はじめてのNNNAILセット等）専用の2つの役割だけを持つ。

  1. <nn-design-picker> のタブ切り替え（ハンド用 / ペディキュア用）
     選択中のデザインが含まれるタブを開いた状態にする。

  2. variant-selects の外にある「セットの内訳」ブロックを、
     バリアント変更時にサーバー再描画結果へ差し替える。
     Dawn の product-info.js は variant-selects 配下と
     price / Sku / Inventory など決まったIDだけを更新するため、
     独自ブロックはここで同じ手当てをする。

  依存: constants.js（PUB_SUB_EVENTS）/ pubsub.js（subscribe）— layout/theme.liquid で読み込み済み。
*/

if (!customElements.get('nn-design-picker')) {
  class NnDesignPicker extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.nn-design__tab'));
      this.grids = Array.from(this.querySelectorAll('.nn-design__grid'));

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.group));
      });

      this.activate(this.groupOfCheckedInput() || this.tabs[0].dataset.group);
    }

    /* 選択済みデザインが属するグループ（タブ）を返す */
    groupOfCheckedInput() {
      const checked = this.querySelector('.nn-design__input:checked');
      return checked?.closest('.nn-design__grid')?.dataset.group || null;
    }

    activate(group) {
      if (!group) return;

      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', tab.dataset.group === group ? 'true' : 'false');
      });

      this.grids.forEach((grid) => {
        grid.hidden = grid.dataset.group !== group;
      });
    }
  }

  customElements.define('nn-design-picker', NnDesignPicker);
}

/*
  メイン画像を商品の1枚目に固定する（セクション設定 lock_featured_media）。

  Liquid 側（product-media-gallery.liquid）でバリアント画像を先頭に持ち上げないように
  しているが、product-info.js はバリアント切替のたびに
  media-gallery.setActiveMedia(variantMediaId, true) を呼んで先頭を差し替える。
  ここでその呼び出しだけを無効化する。

  prepend 引数が判別に使える:
    - バリアント切替（product-info.js）  … prepend = true  → 無効化する
    - サムネイルのクリック（media-gallery.js）… prepend = false → そのまま通す
  ギャラリーに無い media id を渡されると media-gallery.js が
  サムネイル探索で例外を投げ、後続の variantChange の publish まで
  止まってしまうため、通す/止めるの切り分けが必要。
*/
(() => {
  document.querySelectorAll('product-info[data-nn-lock-featured-media] media-gallery').forEach((gallery) => {
    gallery.setActiveMedia = function (mediaId, prepend) {
      if (prepend) return;

      const proto = Object.getPrototypeOf(this);
      if (typeof proto.setActiveMedia === 'function') proto.setActiveMedia.call(this, mediaId, prepend);
    };
  });
})();

/*
  variant-selects の外に置いた要素の同期。
  product-info.js が publish する variantChange には
  再描画済みの html（Document）と sectionId が入っている。

  - セットの内訳ブロック（#NnSetBreakdown-<sectionId>）
  - カートに入れるボタン内の金額（[data-nn-cart-price]）
*/
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  // variant-selects の外にあり、選択中バリアントに応じて変わる要素の id
  const SYNCED_BLOCK_IDS = ['NnSetBreakdown', 'NnSetContents'];

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.html || !data.sectionId) return;

    SYNCED_BLOCK_IDS.forEach((blockId) => {
      const domId = `${blockId}-${data.sectionId}`;
      const source = data.html.getElementById(domId);
      const destination = document.getElementById(domId);

      if (source && destination) destination.innerHTML = source.innerHTML;
    });

    // ボタン内の金額。売り切れ等でボタンが無効なときは金額を隠す。
    const buttonId = `ProductSubmitButton-${data.sectionId}`;
    const sourcePrice = data.html.querySelector(`#${buttonId} [data-nn-cart-price]`);
    const destinationPrice = document.querySelector(`#${buttonId} [data-nn-cart-price]`);

    if (destinationPrice) {
      if (sourcePrice) {
        destinationPrice.textContent = sourcePrice.textContent;
        destinationPrice.hidden = false;
      } else {
        destinationPrice.hidden = true;
      }
    }
  });
})();
